import * as React from 'react';
import { FactureFormaliteApiObject } from '@europrocurement/l2d-domain';
import { InvoiceProvisionPayment } from '@europrocurement/l2d-modules';
import { Box, Card, PaletteColor, Typography, useTheme } from '@mui/material';
import { Switch } from '@europrocurement/flexy-components/components/atoms';
import { Accordion, ListCardBone, SkeletonLoader } from '@europrocurement/flexy-components';

type QuoteAndBillsSectionProps = {
    actif?: boolean;
    handleHideInactivesQuotes: (
        event: React.ChangeEvent<HTMLInputElement>,
        checked: boolean,
    ) => void;
    devisFactures?: React.JSX.Element;
    invoices: FactureFormaliteApiObject[];
    totalRemainingAmount: number;
    invoiceToPayItems: number[];
    onClickDemandeReglement: (type: string) => Promise<void>;
    onClickPaiement: (amount: number, ids: number[], type: 'collection' | 'facture') => void;
};

const QuoteAndBillsSection: React.FunctionComponent<QuoteAndBillsSectionProps> = function ({
    actif,
    handleHideInactivesQuotes,
    devisFactures,
    invoices,
    totalRemainingAmount,
    invoiceToPayItems,
    onClickDemandeReglement,
    onClickPaiement,
}: QuoteAndBillsSectionProps) {
    const { palette } = useTheme();

    return (
        <Card
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                boxShadow: 'none',
                padding: 0,
            }}
            id="devisEtFactures"
        >
            <Accordion
                sx={{
                    boxShadow: 'none',
                }}
                title="Devis et factures"
                titlesSx={{
                    fontWeight: '600',
                    boxShadow: 'none',
                }}
                headerSx={{ boxShadow: 'none' }}
                expanded
                expandColor={palette.text.primary as unknown as PaletteColor}
                expandLabel={
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <Typography
                                variant="l2dh7"
                                sx={{ marginRight: '10px', fontSize: '0.875rem' }}
                            >
                                Cacher les devis inactifs
                            </Typography>
                            <Switch
                                value={actif}
                                checked={actif}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                onChange={handleHideInactivesQuotes}
                            />
                        </Box>
                    </Box>
                }
                footerActions={[
                    invoices.filter((item) => item.factureEnPreparation === false).length > 0 &&
                    totalRemainingAmount > 0 ? (
                        <InvoiceProvisionPayment
                            amount={totalRemainingAmount}
                            isFacture
                            onClickDemandeReglement={() => onClickDemandeReglement('facture')}
                            onClickPaiement={() =>
                                onClickPaiement(totalRemainingAmount, invoiceToPayItems, 'facture')
                            }
                        />
                    ) : null,
                ]}
            >
                <SkeletonLoader
                    isLoading={!devisFactures}
                    skeleton={<ListCardBone />}
                >
                    {devisFactures}
                </SkeletonLoader>
            </Accordion>
        </Card>
    );
};

export default QuoteAndBillsSection;
